import React from "react";
import { Grid } from "@mui/material";
import LabeledSelect from "../../Widgets/LabeledSelect";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import { ClinicalApproachFormValues } from "./interface";
import { TREATMENT_MODALITY_OPTIONS, TREATMENT_MODALITY_RATIONALE_OPTIONS_BY_MODALITY } from "./constants";

interface EditFieldsProps {
  formValues: ClinicalApproachFormValues;
  handleChange: (
    field: keyof ClinicalApproachFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  const rationaleOptions = formValues.treatmentModality
    ? (TREATMENT_MODALITY_RATIONALE_OPTIONS_BY_MODALITY[formValues.treatmentModality] ?? [])
    : [];

  return (
    <Grid container spacing={7}>
      <LabeledSelect
        label="Treatment modality"
        value={formValues.treatmentModality}
        onChange={handleChange("treatmentModality")}
        options={TREATMENT_MODALITY_OPTIONS}
      />
      <LabeledSelect
        label="Treatment modality rationale"
        value={formValues.treatmentModalityRationale}
        onChange={handleChange("treatmentModalityRationale")}
        options={rationaleOptions}
        disabled={!formValues.treatmentModality}
      />
      <LabeledTextArea
        multiline
        minRows={3}
        label="Generalization plan"
        value={formValues.generalizationPlan}
        onChange={handleChange("generalizationPlan")}
        helperText="Describe how you will actively program for generalization across people, settings, and routines, including caregiver implementation outside of sessions."
      />
      <LabeledTextArea
        multiline
        minRows={3}
        label="Maintenance plan"
        value={formValues.maintenancePlan}
        onChange={handleChange("maintenancePlan")}
        helperText="Describe how you will program for maintenance over time, including fading supports, teaching with real materials in natural contexts, and preparing caregivers to sustain progress outside of sessions."
      />
    </Grid>
  );
};

export default EditFields;
